<template>
  <div
    class="addOnFeaturesReview"
    :data-test-id="$testId('container')"
  >
    <InputLabel :text="subHeader" />
    <div
      v-for="(addOn, index) in selectedAddOns"
      :key="index"
      :data-test-id="`selectedAddOns__${index}`"
    >
      <ParagraphBody>
        {{ addOn.displayName }}
      </ParagraphBody>
    </div>
  </div>
</template>

<script>
import {
  InputLabel,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { mapGetters } from 'vuex';
import EventHelper from 'client/GrowthEngineering/EventHelper';

const checkoutModel = 'CheckoutModel';

export default {
  name: 'AddOnFeaturesReview',

  EventHelper,

  components: {
    InputLabel,
    ParagraphBody,
  },

  computed: {
    ...mapGetters(checkoutModel, {
      selectedAddOns: 'getSelectedAddOns',
    }),

    subHeader() {
      return this.selectedAddOns.length > 0 ? 'Add-Ons' : 'No Add-Ons Selected';
    },
  },
};
</script>

<style scoped>
.addOnFeaturesReview {
  display: flex;
  flex-direction: column;
}
</style>
